import "./captcha.scss";
import { LoadingOutlined } from "@ant-design/icons";
import { Layout, Spin } from "antd";
import React from "react";
import { useLocation } from "react-router-dom";
import { DashboardFilterProvider } from "../../modules/Dashboards/hooks/DashboardFilterProvider";
import Header from "../Header";
import ApprovalCollapse from "../PendingApprovals/ApprovalCollapse";
import ApprovalDrawerHeader from "../PendingApprovals/ApprovalDrawerHeader";
import Sidebar from "../Sidebar";
import SideDrawer from "../SideDrawer";
import { useGetOrganization } from "../../../api/v1";
import { isReceiptsModuleEnabled } from "../../../utils/isReceiptsModuleEnabled";

const { Content } = Layout;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const DashboardLayout = (props) => {
  const location = useLocation();
  const isDashboardRoute = location.pathname.includes("dashboard");
  const [isPendingApprovalsDrawerOpen, setIsPendingApprovalsDrawerOpen] = React.useState(false);
  // Infinite cache behavior
  const { organization } = useGetOrganization({
    staleTimeInfinity: true,
  });
  let isPendingApprovalEnabled = organization?.pendingApprovalButton;
  let isReceiptModuleEnabled = isReceiptsModuleEnabled(organization);
  return (
    <DashboardFilterProvider>
      <Layout className="main-layout">
        <Header isPendingApprovalEnabled={isPendingApprovalEnabled} setDrawer={setIsPendingApprovalsDrawerOpen} />
        <Layout>
          <SideDrawer
            openDrawer={isPendingApprovalsDrawerOpen}
            closeDrawer={setIsPendingApprovalsDrawerOpen}
            title={<ApprovalDrawerHeader title="Pending Approvals" count={5} />}
            mask={false}
            placement="right"
            bodyStyle={{ padding: 0 }}
          >
            <ApprovalCollapse isReceiptModuleEnabled={isReceiptModuleEnabled} isPendingApprovalEnabled={isPendingApprovalEnabled} />
          </SideDrawer>
          <Sidebar />
          <Layout className="layout-space">
            <Spin spinning={props.load || false} indicator={antIcon} style={{ position: "fixed" }}>
              <Content className={!isDashboardRoute ? `main-content ${props.className}` : ""}>{props.children}</Content>
            </Spin>
          </Layout>
        </Layout>
      </Layout>
    </DashboardFilterProvider>
  );
};

export default DashboardLayout;
